import React from 'react';
import styled from 'styled-components';

export default props => <Div 
                            wrap={props.wrap ? 1 : 0} 
                            direction={props.direction} 
                            justify={props.justify} 
                            align={props.align} 
                            inline={props.inline} 
                        >{props.children}</Div>

const Div = styled.div`
    
    position:relative;
    display: flex;

    ${props => props.inlinle ? `display: inline-flex;` : ``}
    ${props => props.wrap ? `flex-wrap: wrap;` : ``}
    ${props => props.direction ? `flex-direction: ${props.direction};` : ``}
    ${props => props.justify ? `justify-content: ${props.justify};` : ``}
    ${props => props.align ? `align-items: ${props.align};` : ``}
    
`


// WEBPACK FOOTER //
// ./src/partials/Flex.js